import { Component, ElementRef, Renderer2, ViewChild, inject } from '@angular/core';
import { ModalDialogComponent, ModalDialogModule } from '@vg-constellation/angular-20/modal-dialog';
import { ContentUtil } from '../../utils/content/content.util';
import { environment } from '../../../environments/environment';
import contentFormatUtils from '../../utils/content/content-format.util';
import { ElementConfig } from 'src/app/interfaces/element-config.interface';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { LinkModule } from '@vg-constellation/angular-20/link';

@Component({
    selector: 'zci-secure-modal',
    templateUrl: './secure-modal.component.html',
    styleUrls: ['./secure-modal.component.scss'],
    imports: [
        ModalDialogModule,
        LinkModule,
    ],
})
export class SecureModalComponent {
    private renderer = inject(Renderer2);
    private domSanitizer = inject(DomSanitizer);

    // NOTE: replaced as it's removed in AEM, to be removed in cleanup story
    content = ContentUtil.content;
    variableToReplace: string = '${security-center-link}';
    securityCenterUrl: string = environment.SECURITY_CENTER_URL;
    spaceWithPeriod: string = '&nbsp;.';
    emptyString: string = '';

    @ViewChild('secureModal', { static: false })
    secureModal!: ModalDialogComponent;
    @ViewChild('paragraphWithLinkContainer', { static: false })
    paragraphWithLinkContainer!: ElementRef;

    private linkConfig: ElementConfig = {
        element: 'a',
        variableToReplace: this.variableToReplace,
        attributes: {
            class: 'c11n-link pointer c11n-link--secondary c11n-link--independent',
            href: this.securityCenterUrl,
            'c11n-link': this.emptyString,
        },
        children: [
            {
                element: 'span',
                attributes: { class: 'c11n-link__content' },
                textContent: this.content.applicationSecureInfoMessage.securityCenterLink,
            },
        ],
    };

    open(): void {
        if (this.secureModal) {
            this.clearText2Content();
            this.insertCustomLinkMarkup();
            this.secureModal.openModalDialog();
        }
    }

    close(): void {
        if (this.secureModal) {
            this.secureModal.closeDialogModal();
        }
    }

    sanitizeHtml(contentHtml: string): SafeHtml {
        return contentFormatUtils.sanitizeHtml(this.domSanitizer, contentHtml);
    }

    private clearText2Content() {
        const contentContainer: HTMLElement = this.paragraphWithLinkContainer.nativeElement;
        while (contentContainer.firstChild) {
            this.renderer.removeChild(contentContainer, contentContainer.firstChild);
        }
    }

    private insertCustomLinkMarkup(): void {
        const paragraphWithLinkContainer: HTMLElement =
            this.paragraphWithLinkContainer.nativeElement;

        /**
         * NOTE: remove HTML tags and placeholder variable from provided content paragraph (text2)
         * at the end to replace it with a proper c11n-link markup
         *  */
        const text2HtmlConvertedToPlainText = contentFormatUtils.removeHTMLtags(
            this.content.applicationSecureInfoMessage.text2
                .replace(this.variableToReplace, this.emptyString)
                .replace(this.spaceWithPeriod, this.emptyString),
        );

        const textNode: string = this.renderer.createText(text2HtmlConvertedToPlainText);
        this.renderer.appendChild(paragraphWithLinkContainer, textNode);

        const customLinkElement: HTMLElement = contentFormatUtils.createAndConfigureElement(
            this.renderer,
            this.linkConfig,
        );

        this.renderer.appendChild(paragraphWithLinkContainer, customLinkElement);
        this.renderer.appendChild(paragraphWithLinkContainer, this.renderer.createText('.'));
    }
}
